<template>
  <div class="zoom-player everytown-form">
    <div class="zoom-player__title">{{ title }}</div>
    <div class="zoom-player__subtitle">
      {{ startAt | moment("timezone", "America/Chicago", "dddd M/D/YYYY") }} at
      {{ startAt | moment("timezone", "America/Chicago", "h:mm A") }}
    </div>
    <v-btn @click="openZoomLink" rounded color="#001C60"
      >Click to Connect</v-btn
    >
  </div>
  <!-- <iframe
    frameborder="0"
    allow="autoplay; fullscreen"
    allowfullscreen
    class="zoom-player"
    :src="zoomUrl"
  /> -->
</template>
<script>
export default {
  name: "ZoomPlayer",
  props: {
    zoomLink: String,
    title: String,
    startAt: String,
    event: Object,
  },
  methods: {
    openZoomLink() {
      this.$gtag.event("ZoomLink", {
        event_category: "zoom_link_click",
        event_label: "ZoomLink",
        event_title: this.event.title,
        event_id: this.event.id,
        zoom_link: this.zoomLink,
      });
      window.open(this.zoomLink, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
.zoom-player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  padding-bottom: 6em;

  &__title {
    font-family: $body-font-family;
    font-weight: 500 !important;
    font-size: 48px;
    margin-bottom: 10px;
  }
  &__subtitle {
    font-family: $body-font-family;
    font-weight: 500 !important;
    font-size: 28px;
    line-height: 1.143;
    margin-bottom: 10px;
  }
}
@media screen and (max-width: 960px) {
  .zoom-player {
    padding-bottom: 15%;
    &__title {
      font-size: 30px;
      margin-bottom: 10px;
    }
    &__subtitle {
      font-size: 26px;
      line-height: 1.143;
      margin-bottom: 10px;
    }
  }
}
</style>
